/* src/components/button-elements/DeleteButton.svelte generated by Svelte v3.37.0 */
import {
	SvelteComponent,
	append,
	assign,
	attr,
	bubble,
	compute_rest_props,
	detach,
	element,
	exclude_internal_props,
	get_spread_update,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_attributes,
	svg_element
} from "../../../_snowpack/pkg/svelte/internal.js";

function create_fragment(ctx) {
	let button;
	let svg;
	let g;
	let path;
	let mounted;
	let dispose;

	let button_levels = [
		{
			class: "jd-icon-button jd-icon-button--critical"
		},
		{ "aria-label": "delete" },
		{ type: "button" },
		/*$$restProps*/ ctx[0]
	];

	let button_data = {};

	for (let i = 0; i < button_levels.length; i += 1) {
		button_data = assign(button_data, button_levels[i]);
	}

	return {
		c() {
			button = element("button");
			svg = svg_element("svg");
			g = svg_element("g");
			path = svg_element("path");
			attr(path, "d", "M19.452 7.5H4.547a.5.5 0 00-.5.545l1.287 14.136A2 2 0 007.326 24h9.347a2 2 0 001.992-1.819L19.95 8.045a.5.5 0 00-.129-.382.5.5 0 00-.369-.163zm-9.2 13a.75.75 0 01-1.5 0v-9a.75.75 0 011.5 0zm5 0a.75.75 0 01-1.5 0v-9a.75.75 0 011.5 0zM22 4h-4.75a.25.25 0 01-.25-.25V2.5A2.5 2.5 0 0014.5 0h-5A2.5 2.5 0 007 2.5v1.25a.25.25 0 01-.25.25H2a1 1 0 000 2h20a1 1 0 000-2zM9 3.75V2.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5v1.25a.25.25 0 01-.25.25h-5.5A.25.25 0 019 3.75z");
			attr(g, "fill", "currentColor");
			attr(svg, "width", "14");
			attr(svg, "height", "14");
			attr(svg, "viewBox", "0 0 24 24");
			attr(svg, "focusable", "false");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
			set_attributes(button, button_data);
		},
		m(target, anchor) {
			insert(target, button, anchor);
			append(button, svg);
			append(svg, g);
			append(g, path);

			if (!mounted) {
				dispose = listen(button, "click", /*click_handler*/ ctx[1]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			set_attributes(button, button_data = get_spread_update(button_levels, [
				{
					class: "jd-icon-button jd-icon-button--critical"
				},
				{ "aria-label": "delete" },
				{ type: "button" },
				dirty & /*$$restProps*/ 1 && /*$$restProps*/ ctx[0]
			]));
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(button);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	const omit_props_names = [];
	let $$restProps = compute_rest_props($$props, omit_props_names);

	function click_handler(event) {
		bubble($$self, event);
	}

	$$self.$$set = $$new_props => {
		$$props = assign(assign({}, $$props), exclude_internal_props($$new_props));
		$$invalidate(0, $$restProps = compute_rest_props($$props, omit_props_names));
	};

	return [$$restProps, click_handler];
}

class DeleteButton extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default DeleteButton;